module.exports = __webpack_public_path__ + "img/earth.6b3e3323.png";